module.exports = __webpack_public_path__ + "static/img_9996_dpp_optimized-f35b2b1f2844e0520dcd927df130aa42.jpg";